export default __webpack_public_path__ + "static/media/care-diary-icon.7cc13f3f.png";